"use client";

import { QueryProvider } from "@/providers/QueryProvider";
import { ConfettiProvider } from "@/components/ui/confetti-provider";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import AppInitializer from "@/components/app/AppInitializer";
import { Toaster } from "sonner";
import { CrossDomainSessionProvider } from "@/components/providers/CrossDomainSessionProvider";
import CrossDomainSessionSync from "@/components/auth/CrossDomainSessionSync";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ChunkErrorHandler } from "@/components/ChunkErrorHandler";

export default function ClientProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ErrorBoundary>
      <ChunkErrorHandler />
      <QueryProvider>
          <CrossDomainSessionProvider
            enableDebug={process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_ENABLE_DEBUG_TOOLS === "true"}
            autoSync={true}
            syncInterval={30000}
          >
            <ConfettiProvider>
              <OnboardingProvider>
                <AppInitializer />
                <CrossDomainSessionSync
                  enableDebug={process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_ENABLE_DEBUG_TOOLS === "true"}
                  autoSync={true}
                  syncInterval={30000}
                >
                  {children}
                </CrossDomainSessionSync>
                <Toaster
                  position="top-center"
                  theme="light"
                  style={{
                    zIndex: 99999,
                    position: "fixed",
                    pointerEvents: "auto",
                  }}
                  toastOptions={{
                    classNames: {
                      toast: "bg-[#222] text-white border-none",
                      description: "text-white",
                      success: "bg-[#222] text-white",
                      error: "bg-red-600 text-white",
                    },
                  }}
                />
              </OnboardingProvider>
            </ConfettiProvider>
          </CrossDomainSessionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
